import React from "react";
import { createContext, useState, useEffect } from "react";
import { LoginService } from "../../services/Auth/AuthService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const login = async (username, password) => {
    const isAuthenticated = await LoginService(username, password);
    
    if (!isAuthenticated["error"] && "access_token" in isAuthenticated["content"]) {
      setUser(username);
      const accessToken = isAuthenticated.content.access_token;
      setToken(accessToken);
      localStorage.setItem("token", accessToken);
      return true;
    }

    return false;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("thread_id");
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
